import {Flex} from '@chakra-ui/react'
import Head from 'next/head'
import {useRouter} from 'next/router'
import Script from 'next/script'
import React, {ReactNode} from 'react'
import {sessionStore} from '../../stores/session/sessionStore'
import {THEME_COLOR} from '../../utils/consts'
import LoaderFullScreen from './LoaderFullScreen'
import NavBar from './NavBar'

interface MainLayoutProps {
  children: ReactNode
}

const MainLayout = ({children}: MainLayoutProps) => {
  const router = useRouter()
  const loadingSessionUser = sessionStore(state => state.loadingSessionUser)

  return (
    <>
      <Head>
        <title>Heavnn</title>
        {/* eslint-disable-next-line @next/next/no-page-custom-font */}
        <link
          href='https://fonts.googleapis.com/css?family=Montserrat:100,100italic,200,200italic,300,300italic,400,400italic,500,500italic,600,600italic,700,700italic,800,800italic,900,900italic%7CNunito+Sans:regular,italic,600,700,800&display=optional'
          rel='stylesheet'
        />
        <meta name='theme-color' content={THEME_COLOR} />
      </Head>
      {router.pathname.includes('payment') && <Script src='https://js.stripe.com/v3/' />}
      <Script
        id='beacon'
        dangerouslySetInnerHTML={{
          __html: `!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});
          window.Beacon('init', '1f4bbe19-7da5-4492-92c3-aebc4cf8a0cd')`,
        }}
      />
      <Script
        id='firstpromoter'
        dangerouslySetInnerHTML={{
          __html: `(function(w){w.fpr=w.fpr||function(){w.fpr.q = w.fpr.q||[];w.fpr.q[arguments[0]=='set'?'unshift':'push'](arguments);};})(window);fpr("init", {cid:"rl5g3iei"}); fpr("click");`,
        }}
      />
      <Script id='firstpromoter2' src='https://cdn.firstpromoter.com/fpr.js' />
      <Flex direction='column' minH='100vh' backgroundColor='#F7F7F7'>
        <NavBar />
        <Flex direction='column' minH='calc(100vh - 64px)'>
          {loadingSessionUser ? <LoaderFullScreen /> : children}
        </Flex>
      </Flex>
    </>
  )
}

export default MainLayout
